import AvatarCustom from './AvatarCustom';

export default AvatarCustom;
